(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const nav = document.getElementById('brands-nav');
    if (!nav) return;

    const updateScrollOffset = () => {
      const headerHeight = parseFloat(
        getComputedStyle(document.body).getPropertyValue('--header-height') || '0'
      );
      const navHeight = nav.offsetHeight;
      document.documentElement.style.setProperty(
        '--brands-scroll-offset',
        `${headerHeight + navHeight}px`
      );
    };

    updateScrollOffset();
    new ResizeObserver(updateScrollOffset).observe(nav);

    const links = nav.querySelectorAll('.brands-nav__link[href^="#brands-"]');
    const sections = document.querySelectorAll('.brands-section[id]');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            links.forEach((link) => {
              link.classList.toggle(
                'brands-nav__link--active',
                link.getAttribute('href') === `#${entry.target.id}`
              );
            });
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );

    sections.forEach((section) => observer.observe(section));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
